import Typography from 'typography';

const typography = new Typography({
  title: 'Workplaces',
  baseFontSize: '15px',
  baseLineHeight: 1.45,
  headerFontFamily: [
    'serif',
  ],
  bodyFontFamily: [
    'sans-serif',
  ],
  googleFonts: [
    {
      name: 'Open Sans',
      styles: ['400'],
    },
  ],
  scaleRatio: 3.998,
  overrideStyles: () => ({
    img: {
      marginBottom: 0,
    },
  }),
});

export default typography;



// WEBPACK FOOTER //
// ./config/typography.js